/**
 * returns the intersection of two arrays with option property comparison selector
 */
export function arrayIntersect<T = any, U = T>(
  arrayA: T[],
  arrayB: U[],
  selector: (value: any) => any = value => value
): (T | U)[] {
  return arrayA.filter(itemA => !!arrayB.find(itemB => selector(itemB) === selector(itemA)));
}
